import base from './base.repository'
export default {
    ...base,
    getEntryMasterData() {
        this.get(`vehicle-entries/master-data`)
        return this
    },
    registerEntry(payload) {
        this.post(`vehicle-entries`, payload)
        return this
    },
    getTypes() {
        this.get('vehicle-types')
        return this
    },
    byPlate(plate) {
        this.get(`vehicles?plate=${plate}`)
        return this
    },
    searchVehiclesOfClient(clientId, filters, page) {
        const params = { ...filters, page, client: clientId }
        this.get(`vehicles${this.querify(params)}`)
        return this
    },
    saveVehicle(vehicle) {
        this.post(`vehicles`, vehicle)
        return this
    },
    updateVehicle(vehicle, id) {
        this.put('vehicles/' + id, vehicle)
        return this
    },
    deleteVehicle(id, userId) {
        this.delete('vehicles/' + id + '?user=' + userId)
        return this
    },
    savePhotos(payload) {
        this.post('vehicles/save-photos', payload)
        return this
    },
    getVehicleEntriesByClient(clientId, page, filters) {
        const theFilters = [`client=${clientId}`, `page=${page}`]

        Object.keys(filters).map(key => {
            !!filters[key] && theFilters.push(`${key}=${filters[key]}`)
        })

        const queryParams = theFilters.join('&')
        const queryString = !!theFilters ? `?${queryParams}` : ''

        this.get(`vehicle-entries${queryString}`)

        return this
    },
    getVehicleEntriesByClientAndVehicle(clientId, plate) {
        this.get(`vehicle-entries?plate=${plate}&client=${clientId}`)
        return this
    },
}
